/**
 * What "Tentar agora" (``manual``) and the 20 s timer do while the API is
 * down:
 * - ``failed``: refetch the active queries that ended in error;
 * - ``active``: none failed — only a mutation (save, generate…) marked the
 *   API down — so the active queries are re-read as the probe; their first
 *   success clears the banner;
 * - ``clear``: no active query to probe with, and the user asked: the banner
 *   goes away, and the next failure by network brings it back;
 * - ``wait``: the same, but from the timer. With nothing to probe, hiding
 *   the banner on its own would claim the API is back without evidence.
 */
export type ReconnectPlan = 'failed' | 'active' | 'clear' | 'wait'

export function reconnectPlan(failedActive: number, active: number, manual: boolean): ReconnectPlan {
  if (failedActive > 0) return 'failed'
  if (active > 0) return 'active'
  return manual ? 'clear' : 'wait'
}
